import React from 'react';
import { Popup } from 'semantic-ui-react';

export const NumLikes = ({ children }) => (
  <Popup
    trigger={children}
    content="推文數"
    position="bottom center"
  />
);

export const NumHates = ({ children }) => (
  <Popup
    trigger={children}
    content="噓文數"
    position="bottom center"
  />
);

export const NumReplies = ({ children }) => (
  <Popup
    trigger={children}
    content="回文數"
    position="bottom center"
  />
);

export const NumArticles = ({ children }) => (
  <Popup
    trigger={children}
    content="文章數"
    position="bottom center"
  />
);
